import BaseMotorCard from './BaseMotorCard';
import { DeviceCardProps } from '../DeviceCardProps';
import { HighTorqueMotorIcon } from '../../../Icons/Bits';
import { MOTOR_TYPE } from '../../../../utils/constants';

interface HighTorqueMotorCardProps extends DeviceCardProps {
  id: string;
  header: string;
}

const HighTorqueMotorCard = (props: HighTorqueMotorCardProps) => {
  return <BaseMotorCard {...props} headerIcon={HighTorqueMotorIcon} motorType={MOTOR_TYPE.HIGH_TORQUE} />;
};

export default HighTorqueMotorCard;
